import { render } from "./PhotoEditor.vue?vue&type=template&id=7d366706"
import script from "./PhotoEditor.vue?vue&type=script&lang=js"
export * from "./PhotoEditor.vue?vue&type=script&lang=js"

import "./PhotoEditor.vue?vue&type=style&index=0&id=7d366706&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__